var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('log-table',{attrs:{"loading":_vm.loading,"logs":_vm.logs},on:{"get-logs":_vm.getLogs}})
}
var staticRenderFns = []

export { render, staticRenderFns }